export interface ICustomerEpcCalculation {
  epcCost: number;
  rate: number;
  escalator: number;
  systemSize: number;
  annualProduction: number;
  pricePerWatt: number;
  yield: number;
}

export class CustomerEpcCalculation implements ICustomerEpcCalculation {
  epcCost: number;
  rate: number;
  escalator: number;
  systemSize: number;
  annualProduction: number;
  pricePerWatt: number;
  yield: number;
}
